import apiClient from "../config/api";

const pmMatrixService = {
  getMatrixData: async (tenantId, plantId, assetId, planId, year) => {
    const params = { tenantId, year };
    if (plantId) params.plantId = plantId;
    if (assetId) params.assetId = assetId;
    if (planId) params.planId = planId;

    const response = await apiClient.get("/pm-matrix", { params });
    return response.data;
  },

  toggleSchedule: async (planId, taskId, month, year, isScheduled) => {
    const response = await apiClient.post("/pm-matrix/schedule", {
      planId,
      taskId,
      month,
      year,
      isScheduled,
    });
    return response.data;
  },

  logExecution: async (matrixScheduleId, technicianId, status, notes) => {
    const response = await apiClient.post("/pm-matrix/execute", {
      matrixScheduleId,
      technicianId,
      status,
      notes,
    });
    return response.data;
  },

  getComplianceHeatmap: async (tenantId, year) => {
    const response = await apiClient.get("/pm-matrix/heatmap", {
      params: { tenantId, year },
    });
    return response.data;
  },
};

export default pmMatrixService;
